<template>
  <div
    class="permission-select"
    :style="{
      backgroundColor: '#fff'
    }"
    @click="handlePermission"
  >
    <div class="permission-select-text">
      <template v-if="userRange.length">
        <el-tag
          v-for="tag in userRange"
          :key="tag.id"
          closable
          :disable-transitions="true"
          type="info"
          @close="handleRemoveArr(tag.id)"
        >
          {{ tag.name }}
        </el-tag>
      </template>
      <el-tag
        v-else-if="showAllCompany && !userRange.length"
        closable
        :disable-transitions="true"
        type="info"
        @close="emits('update:showAllCompany', false)"
      >
        全公司
      </el-tag>
      <div v-else class="placeholder">请选择</div>
    </div>
    <i class="icon-arrow-down-s-line permission-select-btn t-iconfont"></i>
  </div>
</template>

<script setup>
import xbb from '@xbb/xbb-utils'
import xbbSdk from 'xbb-sdk'
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { usePersonSelectStore } from '@/store/personSelectStore'

const personSelectStore = usePersonSelectStore()

const props = defineProps({
  userRange: {
    type: Array,
    default: () => []
  },
  extraOptions: {
    type: Object,
    default: () => ({})
  },
  showAllCompany: {
    type: Boolean,
    default: true
  }
})

const emits = defineEmits(['update:userRange', 'update:showAllCompany'])

// 生成唯一ID
const instanceId = ref(xbb.guid())
const defaultOptions = ref({
  activeTabName: 'dept',
  defaultVal: [],
  showTabsName: ['dept', 'user', 'role'],
  otherParams: {
    // 是否控制组织架构权限范围
    deptVisibleRule: true,
    parentStrictly: true
  }
})

// 使用范围点击弹出部门、成员、角色选择弹窗
const handlePermission = () => {
  // 设置当前实例为活动实例
  personSelectStore.setActiveInstance(instanceId.value)
  const scopeRule = xbb.deepClone(props.userRange)

  xbbSdk.sendMessage('personSelect', {
    ...xbb.deepClone(defaultOptions.value),
    ...xbb.deepClone(props.extraOptions),
    defaultVal: Object.keys(scopeRule).length === 0 ? [] : scopeRule
  })
}

// 使用范围tag点击指定删除
const handleRemoveArr = (id) => {
  emits(
    'update:userRange',
    props.userRange.filter((i) => i.id !== id)
  )
}

// 确认选择
const personSubmit = (data) => {
  emits('update:userRange', data)
  emits('update:showAllCompany', false)
  // 处理完成后清除活动实例状态
  personSelectStore.clearActiveInstance()
}

const getMessageFormXbb = (event) => {
  const { data, type } = event.data
  // 非当前活动实例则不处理消息
  if (type !== 'personSelectResult' || personSelectStore.getActiveInstance() !== instanceId.value) {
    return
  }
  switch (type) {
    case 'personSelectResult':
      personSubmit(data)
      break
    default:
      break
  }
}

onMounted(() => {
  window.addEventListener('message', getMessageFormXbb)
  console.log(props.userRange)
})

onBeforeUnmount(() => {
  window.removeEventListener('message', getMessageFormXbb)
})
</script>

<style lang="scss" scoped>
.placeholder {
  margin-left: 5px;
  font-size: 14px;
  color: #a9abb3;
}
.permission-select {
  display: flex;
  width: 100%;
  overflow: hidden;
  border: 1px solid #e5e6eb;
  border-radius: 8px;
  margin-bottom: 16px;
  .permission-select-text {
    :deep(.el-tag) {
      margin-right: 6px;
    }
    box-sizing: border-box;
    display: flex;
    flex: auto;
    align-items: center;
    height: 32px;
    padding-right: 4px;
    padding-left: 4px;
    overflow-x: auto;
    line-height: 30px;
    cursor: pointer;
  }
  .permission-select-btn {
    display: flex;
    align-items: center;
    margin: 0 12px 0 8px;
  }
}
</style>
